import {get, post, del, downloadGet, downloadPost} from './axios2'
import {addHeaders} from 'src/utilities/authHeader'
import Constants from './constants'
import {OK} from 'http-status-codes'
import mime from 'mime-types'

const fileManagerApiUri = process.env.VUE_APP_FILE_MANAGER_API_URI+ '/'

export async function fetchDirectoryContents(path) {
  return await get(fileManagerApiUri + 'folders?p=' + encodeURIComponent(path), await addHeaders())
}

export async function deleteFile(file) {
  let uri = fileManagerApiUri + 'files?p=' + encodeURIComponent(file.path)

  if (file.name) {
    uri += '%2f' + encodeURIComponent(file.name)
  }

  return await del(uri, await addHeaders())
}

export async function downloadFile(payload) {
  if (payload.useDirectFileUploadAndDownload) {
    const url = `${fileManagerApiUri}files?p=${encodeURIComponent(payload.path)}/${encodeURIComponent(payload.name)}`
    const headers = await addHeaders(Constants.HEADERS.FILE_DOWNLOAD.headers)
    return await downloadGet(url, headers)
  }

  return await downloadFileFromS3(payload)
}

export async function downloadFileFromS3(payload) {
  const url = `${fileManagerApiUri}aws/s3/copyFromEfsAndGenerateDownloadUrl?p=${encodeURIComponent(payload.path)}/${encodeURIComponent(payload.name)}`
  const response = await get(url, await addHeaders())

  if (OK === response.status) {
    const s3DownloadUrl = response.data
    return await downloadGet(s3DownloadUrl, { 'content-type': mime.lookup(payload.name) })
  }
}

export async function downloadFlattenedPdf(file) {
  const url = `${fileManagerApiUri}files/flatten-pdf?p=${encodeURIComponent(file.path)}/${encodeURIComponent(file.name)}`
  const headers = await addHeaders(Constants.HEADERS.FILE_DOWNLOAD.headers)
  return await downloadGet(url, headers)
}

export async function downloadFilesForSelectedPaths(filePaths, isPdfsLocked) {
  const url = `${fileManagerApiUri}files/zip${isPdfsLocked ? '-flatten' : ''}`
  const headers = await addHeaders(Constants.HEADERS.FILE_DOWNLOAD.headers)
  return await downloadPost(url, headers, filePaths)
}

export async function createFolder(folderName) {
  return await post(`${fileManagerApiUri}folders`, await addHeaders(), {path: folderName})
}

export async function fileManagerApiUp() {
  return await get(fileManagerApiUri + 'actuator/health', await addHeaders())
}

export async function listReports() {
  return await get(fileManagerApiUri + 'aws/s3/listReports', await addHeaders())
}

export async function presignedS3GetReportUrl(fileName, headers) {
  return await get(fileManagerApiUri + `aws/s3/generateGetReportUrl?fileName=${encodeURIComponent(fileName)}`, await addHeaders(headers))
}

export async function presignedS3PutUrlsFileUploads(files) {
  return await post(fileManagerApiUri + 'aws/s3/generatePutFileUploadsUrls', await addHeaders(), files)
}
